import { Component, ElementRef, ViewChild } from '@angular/core';
// import { CanvasComponent } from "src/canvas/canvas.component";
// import { saveAs } from 'file-saver';
import { AutoCompleteBoxComponent } from 'src/app/autoCompleteBox/autoCompleteBox.component';

@Component({
  selector: 'sReceiptTable',
  templateUrl: 'sReceiptTable.component.html',
  styleUrls: ['sReceiptTable.component.css'],
})
export class SReceiptTableComponent {
  // @ViewChild("canvasComp") canvasComp: ElementRef<CanvasComponent>;
  @ViewChild('autoCompleteBoxComp')
  autoCompleteBoxRF: ElementRef<AutoCompleteBoxComponent>;

  tableData;
  receiptData;
  receiptItemOver;
  lastClickedWord: any;
  currentItemType: any;
  currentItem: any;
  lastTarget: any;
  origReceiptData: any;
  popupPositionLeft: number = 0;
  popupPositionTop: number = 0;
  showAutoCompleteBox: string = 'none';
  uid: string = '';

  ngAfterViewInit() {
    var autoCompleteBox = this
      .autoCompleteBoxRF as unknown as AutoCompleteBoxComponent;
    autoCompleteBox.cancel = () => {
      this.showAutoCompleteBox = 'none';
    };
    autoCompleteBox.clickItem = ($event, item) => {
      this.currentItem.value = item;
    };
  }



  printScore(item) {
    const conf = Math.round(item.value.word.confidence * 100);
    if (!item.value.score) return conf;
    const score = Math.round(item.value.score * 100);
    return score;
  }
  displayTable(body: any) {
    this.receiptData = body;
    this.uid = body.uid;
    let color = 'black';
    if (body['prices']['taxAndTotal']['total']['score'] < 0.40) {
      color = 'red';
    }
    let tableDataTmp = [
      {
        key: 'title',
        label: { word: { text: 'כותרת' } },
        value: body['names']['sentences'][0] ?? { word: { text: '' } },
        autoCompleteList: body['names']['sentences'],
        chosen: false,
      },
      {
        key: 'total',
        label: { word: { text: 'סה"כ' } },
        value: body['prices']['taxAndTotal']['total'] ?? { word: { text: '' } },
        autoCompleteList: body['prices']['scoreList'],
        color: color,
        chosen: false,
      },
      {
        key: 'tax',
        label: { word: { text: 'מעמ' } },
        value: body['prices']['taxAndTotal']['tax'] ?? { word: { text: '' } },
        color: color,
        chosen: false,
      },
      {
        key: 'subtotal',
        label: { word: { text: 'לפני מעמ' } },
        value: body['prices']['taxAndTotal']['subtotal'] ?? {
          word: { text: '' },
        },
        color: color,
        chosen: false,
      },
      {
        key: 'invoiceNumber',
        label: { word: { text: 'מספר חשבונית' } },
        value: body['receiptNumbers']['scoreList'][0] ?? { word: { text: '' } },
        chosen: false,
      },
      {
        key: 'date',
        label: { word: { text: 'תאריך' } },
        value: body['dates']['scoreList'][0] ?? { word: { text: '' } },
        chosen: false,
      },
      {
        key: 'phone',
        label: { word: { text: 'טלפון' } },
        value: body['phone'],
        chosen: false,
      },
      {
        key: 'orgId',
        label: { word: { text: 'עוסק' } },
        value: body['orgId']['scoreList'][0] ?? { word: { text: '' } },
        chosen: false,
      },
      {
        key: 'haqtza',
        label: { word: { text: 'הקצאה' } },
        value: body['haqtza']?.['scoreList']?.[0] ?? { word: { text: '' } },
        chosen: false,
      },
    ];
    this.tableData = [];
    for (let item of tableDataTmp) {
      if (this.printScore(item)) {
        this.tableData.push(item);
      }
    }

    // console.log("body", body);
    // body.receiptJson = body.words;
    // for (let item of body.receiptJson) {
    //   if (item.header == null) item.header = { text: " " };
    //   if (item.label == null) item.label = { text: " " };
    //   // console.log("item.header.length",item.header.length);
    // }
    // this.receiptData = body.receiptJson;
    // for (let item of this.receiptData) {
    //   item["value"]["orig"] = item["value"]["text"];
    //   item["label"]["orig"] = item["label"]["text"];
    //   item["header"]["orig"] = item["header"]["text"];
    // }
    // this.origReceiptData = JSON.parse(JSON.stringify(body.receiptJson));
  }

  unchooseTr() {
    if (!this.tableData) return;
    for (let item of this.tableData) {
      item.chosen = false;
    }
  }

  // downloadCsv() {
  //   var data = this.receiptData;
  //   const replacer = (key, value) => (value === null ? "" : value.text); // specify how you want to handle null values here
  //   const header = Object.keys(data[0]);
  //   delete header["chosen"];
  //   let csv = data.map((row) =>
  //     header
  //       .map((fieldName) => JSON.stringify(row[fieldName], replacer))
  //       .join(",")
  //   );
  //   csv.unshift(header.join(","));
  //   let csvArray = csv.join("\r\n");

  //   var blob = new Blob([csvArray], { type: "text/csv" });
  //   saveAs(blob, "receipt.csv");
  // }

  itemFocusout() {
    // setTimeout(
    //   function () {
    //     this.showAutoCompleteBox = "none";
    //   }.bind(this),
    //   1000
    // );
  }

  tableItemDown($event, type, item) {
    console.log($event);

    $event.currentTarget.style.backgroundColor = 'yellow';
    if (this.lastTarget && this.lastTarget != $event.currentTarget) {
      this.lastTarget.style.backgroundColor = 'white';
    }
    this.lastTarget = $event.currentTarget;
    this.currentItemType = item[type];
    this.currentItem = item;

    let autoCompleteList = item['autoCompleteList'];
    if (autoCompleteList) {
      this.showAutoCompleteBox = 'block';
      let box = $event.currentTarget.getBoundingClientRect();
      // this.popupPositionTop = box.top
      this.popupPositionLeft = window.innerWidth * 0.6 - 200;

      console.log(autoCompleteList);
      var autoCompleteBox = this
        .autoCompleteBoxRF as unknown as AutoCompleteBoxComponent;
      autoCompleteBox.autoCompleteList = autoCompleteList;
    } else {
      this.showAutoCompleteBox = 'none';
    }
  }

  wordClicked(word: any) {
    if (this.lastClickedWord == word) return;
    // console.log(word["description"]);
    this.lastClickedWord = word;
    setTimeout(() => {
      this.lastClickedWord = null;
    }, 1000);
    if (this.currentItemType) {
      this.currentItemType.word.text += ` ${word['description']}`;
    }
  }
  addRow() {
    this.tableData.unshift({
      label: { word: { text: '' } },
      value: { word: { text: '' } },
      chosen: true,
    });
  }
  restart() {
    this.unchooseTr();
    this.tableData = null;
  }
  downloadImg() {
    const imgBase64 =     `data:image/png;base64, ${this.receiptData.imgBase64}`;
    const link = document.createElement('a');
    link.href = imgBase64;
    link.download = 'receipt.png';
    link.click();
  }
}
